import { render, staticRenderFns } from "./TheNavbarTopPanelInfoButton.vue?vue&type=template&id=62a60834&scoped=true&"
import script from "./TheNavbarTopPanelInfoButton.vue?vue&type=script&lang=js&"
export * from "./TheNavbarTopPanelInfoButton.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarTopPanelInfoButton.vue?vue&type=style&index=0&id=62a60834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a60834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCol})
